import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40101 32863"
    {...props}
  >
    <path
      d="M25224 27311 20080 8260l-5203 19051c-407 1451-725 2487-962 3116-237 622-659 1192-1251 1688s-1377 748-2361 748c-799 0-1451-149-1962-445-518-296-932-718-1250-1258s-578-1184-778-1932c-207-740-384-1428-547-2065L481 5766C163 4522 0 3575 0 2924c0-822 289-1518 866-2080C1444 281 2161 0 3012 0c1177 0 1962 377 2369 1125 399 755 755 1843 1058 3279l4167 18555 4663-17363c348-1333 659-2346 933-3035 274-696 725-1295 1347-1798 622-511 1465-763 2531-763 1088 0 1932 267 2531 792 600 525 1014 1103 1244 1725 229 621 540 1643 933 3079l4707 17363 4167-18555c199-969 392-1732 570-2280 185-548 495-1043 932-1473 444-436 1081-651 1924-651 837 0 1547 281 2132 837 585 555 881 1250 881 2087 0 592-155 1539-474 2842l-5292 21397c-362 1443-666 2502-903 3175-237 674-644 1259-1214 1762-569 511-1377 763-2420 763-984 0-1769-245-2361-741-592-488-1006-1043-1236-1657-237-615-555-1666-977-3154z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
